import {REGSCREEN} from 'store/m-types'

function initMenu(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                navTo: '/fmc/index',
            },
            l2: {
                navTo: '/acars/index',
            },
            l3: {
                navTo: '/dfdau/index',
            },
            r6: {
                navTo: '/setup/index',
            },
        }
    }

    let screen = page1

    that.$store.commit(REGSCREEN, screen)
}

function initIndex(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                navTo: '/fmc/ident',
            },
            l2: {
                navTo: '/fmc/pos',
            },
            l3: {
                navTo: '/fmc/perf',
            },
            l4: {
                navTo: '/fmc/takeoff',
            },
            l5: {
                navTo: '/fmc/approach',
            },
            l6: {
                navTo: '/fmc/offset',
            },
            r1: {
                navTo: '/fmc/navdata',
            },
            r2: {
                navTo: '/fmc/msgrecall',
            },
            r3: {
                navTo: '/fmc/altndest',
            },
            r6: {
                navTo: '/fmc/maint',
            },
        }
    }
    
    let screen = page1

    that.$store.commit(REGSCREEN, screen)
}

function initIdent(that){
        let page1 = {
            content: that.showData,
            from: '',
            behaviours:{
                l6: {
                    navTo: '/fmc/index',
                },
                r2: {
                    navTo: '',
                    reproduction: true,
                    modify: true
                },
                r6: {
                    navTo: '/fmc/pos',
                },
            }
        }
        
        let page2 = {
            content: that.showData,
            from: '',
            behaviours:{
                l6: {
                    navTo: '/fmc/index',
                },
                r6: {
                    navTo: '/fmc/pos',
                },
            }
        }
        
        let screen = ''
    
        if('page'+that.index[0] === 'page1'){
            screen = page1
        }else if ('page'+that.index[0] === 'page2'){
            screen = page2
        }

        that.$store.commit(REGSCREEN, screen)
}

function initPos(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l2: {
                modify: true
            },
            l3: {
                modify: true
            },
            l6: {
                navTo: '/fmc/index',
            },
            r1: {
                reproduction: true
            },
            r4: {
                modify: true
            },
            r5: {
                modify: true
            },
            r6: {
                navTo: '/fmc/rte'
            },
        }
    }
    
    let page2 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                reproduction: true
            },
            l2: {
                reproduction: true
            },
            l3: {
                reproduction: true
            },
            l4: {
                reproduction: true
            },
            l5: {
                reproduction: true
            },
            l6: {
                reproduction: true
            }
        }
    }

    let page3 = {
        content: that.showData,
        from: '',
        behaviours:{
            l6: {
                navTo: '/fmc/index',
            },
            r5: {
                navTo: '/fmc/navstatus',
            },
        }
    }
    
    let screen = ''

    if('page'+that.index[0] === 'page1'){
        screen = page1
    }else if ('page'+that.index[0] === 'page2'){
        screen = page2
    }else if ('page'+that.index[0] === 'page3'){
        screen = page3
    }

    that.$store.commit(REGSCREEN, screen)
}

function initPerf(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            },
            l2: {
                modify: true
            },
            l3: {
                modify: true
            },
            l4: {
                modify: true
            },
            l5: {
                modify: true
            },
            l6: {
                navTo: '/fmc/index',
            },
            r1: {
                modify: true
            },
            r2: {
                modify: true
            },
            r5: {
                modify: true
            },
            r6: {
                navTo: '/fmc/n1limit'
            },
        }
    }
    
    let page2 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                reproduction: true
            },
            l2: {
                reproduction: true
            },
            l3: {
                reproduction: true
            },
            l4: {
                reproduction: true
            },
            l5: {
                reproduction: true
            },
            l6: {
                reproduction: true
            }
        }
    }

    let page3 = {
        content: that.showData,
        from: '',
        behaviours:{
            l6: {
                navTo: '/fmc/index',
            },
            r5: {
                navTo: '/fmc/nav%20status',
            },
        }
    }
    
    let screen = ''

    if('page'+that.index[0] === 'page1'){
        screen = page1
    }else if ('page'+that.index[0] === 'page2'){
        screen = page2
    }else if ('page'+that.index[0] === 'page3'){
        screen = page3
    }

    that.$store.commit(REGSCREEN, screen)
}

function initTakeoff(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            },
            l2: {
                
            },
            l3: {
                modify: true
            },
            l4: {
                
            },
            l5: {
                
            },
            l6: {
                navTo: '/fmc/perf',
            },
            r1: {
                modify: true
            },
            r2: {
                modify: true
            },
            r5: {
                modify: true
            },
            r6: {
                modify: true
            },
        }
    }
    
    let page2 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            },
            l2: {
                modify: true
            },
            l3: {
                
            },
            l4: {
                modify: true
            },
            l5: {
                modify: true
            },
            l6: {
                navTo: '/fmc/perf',
            },
            r1: {
                modify: true
            },
            r2: {
                modify: true
            },
            r4: {
                modify: true
            },
            r6: {
                modify: true
            },
        }
    }


    let screen = ''

    if('page'+that.index[0] === 'page1'){
        screen = page1
    }else if ('page'+that.index[0] === 'page2'){
        screen = page2
    }

    that.$store.commit(REGSCREEN, screen)
}

function initApproach(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            },
            l2: {
                
            },
            l3: {
                modify: true
            },
            l4: {
                
            },
            l5: {
                
            },
            l6: {
                navTo: '/fmc/perf',
            },
            r1: {
                modify: true
            },
            r2: {
                modify: true
            },
            r5: {
                modify: true
            },
            r6: {
                modify: true
            },
        }
    }


    let screen = ''

    if('page'+that.index[0] === 'page1'){
        screen = page1
    }else if ('page'+that.index[0] === 'page2'){
        screen = page2
    }

    that.$store.commit(REGSCREEN, screen)
}

function initOffset(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            },
            l2: {
                
            },
            l3: {
                modify: true
            },
            l4: {
                
            },
            l5: {
                
            },
            l6: {
                navTo: '/fmc/perf',
            },
            r1: {
                modify: true
            },
            r2: {
                modify: true
            },
            r5: {
                modify: true
            },
            r6: {
                modify: true
            },
        }
    }


    let screen = ''

    if('page'+that.index[0] === 'page1'){
        screen = page1
    }else if ('page'+that.index[0] === 'page2'){
        screen = page2
    }

    that.$store.commit(REGSCREEN, screen)
}

function initNanData(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            },
            l2: {
                
            },
            l4: {
                
            },
            l6: {
                navTo: '/fmc/index',
            },
            r1: {
                modify: true
            },
            r2: {
                navTo: ''
            },
            r6: {
                navTo: '/fmc/navoptions'
            },
        }
    }


    let screen = ''

    if('page'+that.index[0] === 'page1'){
        screen = page1
    }else if ('page'+that.index[0] === 'page2'){
        screen = page2
    }

    that.$store.commit(REGSCREEN, screen)
}

function initMsgRecall(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{}
    }

    let screen = page1

    that.$store.commit(REGSCREEN, screen)
}

function initAltnDest(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            L1: {
                modify: true
            },
            l2: {
                modify: true
            },
            l3: {
                modify: true
            },
            l4: {
                modify: true
            },
            l5: {
                modify: true
            },
            l6: {
                navTo: '/fmc/index',
            },
            r1: {},
        }
    }
    
    let page2 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            },
        }
    }
    let page3 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            },
        }
    }
    let page4 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            },
        }
    }
    let page5 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            },
        }
    }
    let page6 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            },
        }
    }
    
    let screen = ''

    if('page'+that.index[0] === 'page1'){
        screen = page1
    }else if ('page'+that.index[0] === 'page2'){
        screen = page2
    }else if ('page'+that.index[0] === 'page3'){
        screen = page3
    }else if ('page'+that.index[0] === 'page4'){
        screen = page4
    }else if ('page'+that.index[0] === 'page5'){
        screen = page5
    }else if ('page'+that.index[0] === 'page6'){
        screen = page6
    }

    that.$store.commit(REGSCREEN, screen)
}

function initRte(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            }
        }
    }
    
    let page2 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            },
            l2: {
                modify: true
            },
            r1: {
                modify: true
            },
            r2: {
                modify: true
            },
        }
    }

    let screen = ''

    if('page'+that.index[0] === 'page1'){
        screen = page1
    }else if ('page'+that.index[0] === 'page2'){
        screen = page2
    }

    that.$store.commit(REGSCREEN, screen)
}

function initClb(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            },
            l2: {},
            l3: {
                modify: true
            },
            l5: {
                navTo: ''
            },
            l6: {
                navTo: '',
            },
            r2: {
                modify: true
            },
            r5: {
                navTo: ''
            },
            r6: {
                navTo: ''
            },
        }
    }

    let screen = page1

    that.$store.commit(REGSCREEN, screen)
}

function initCrz(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            },
            l6: {
                navTo: '',
            },
            r5: {
                navTo: ''
            },
            r6: {
                navTo: ''
            },
        }
    }

    let screen = page1

    that.$store.commit(REGSCREEN, screen)
}

function initForecast(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l6: {
                navTo: '',
            },
            r3: {
                modify: true
            }
        }
    }

    let screen = page1

    that.$store.commit(REGSCREEN, screen)
}

function initDes(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l6: {
                navTo: '/fmc/forecast',
            },
            r3: {
                modify: true
            }
        }
    }

    let screen = page1

    that.$store.commit(REGSCREEN, screen)
}

function initDepArr(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l6: {
                navTo: '',
            },
            r3: {
                modify: true
            }
        }
    }

    let screen = page1

    that.$store.commit(REGSCREEN, screen)
}

function initFix(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            }
        }
    }
    let page2 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            }
        }
    }
    let page3 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            }
        }
    }
    let page4 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            }
        }
    }
    let page5 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            }
        }
    }
    let page6 = {
        content: that.showData,
        from: '',
        behaviours:{
            l1: {
                modify: true
            }
        }
    }

    let screen = ''

    if('page'+that.index[0] === 'page1'){
        screen = page1
    }else if ('page'+that.index[0] === 'page2'){
        screen = page2
    }else if ('page'+that.index[0] === 'page3'){
        screen = page3
    }else if ('page'+that.index[0] === 'page4'){
        screen = page4
    }else if ('page'+that.index[0] === 'page5'){
        screen = page5
    }else if ('page'+that.index[0] === 'page6'){
        screen = page6
    }

    that.$store.commit(REGSCREEN, screen)
}

function initHold(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l6: {
                navTo: '',
            },
            r3: {
                modify: true
            }
        }
    }

    let screen = page1

    that.$store.commit(REGSCREEN, screen)
}

function initLegs(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l6: {
                navTo: '',
            },
            r3: {
                modify: true
            }
        }
    }

    let screen = page1

    that.$store.commit(REGSCREEN, screen)
}

function initN1Limit(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l6: {
                navTo: '/fmc/perf',
            },
            r6: {
                navTo: '/fmc/takeoff'
            }
        }
    }

    let screen = page1

    that.$store.commit(REGSCREEN, screen)
}

function initProg(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l6: {
                navTo: '',
            },
            r6: {
                navTo: '/fmc/navstatus'
            }
        }
    }

    let screen = page1

    that.$store.commit(REGSCREEN, screen)
}

function initNavStatus(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            l6: {
                navTo: '/fmc/index',
            },
            r6: {
                navTo: '/fmc/pos?index=3',
            }
        }
    }

    let page2 = {
        content: that.showData,
        from: '',
        behaviours:{
            l6: {
                navTo: '/fmc/index',
            }
        }
    }

    let screen = ''

    if('page'+that.index[0] === 'page1'){
        screen = page1
    }else if ('page'+that.index[0] === 'page2'){
        screen = page2
    }

    that.$store.commit(REGSCREEN, screen)
}

function initMaintIndex(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            L1: {
                modify: true
            },
            l2: {
                modify: true
            },
            l3: {
                modify: true
            },
            l4: {
                modify: true
            },
            l5: {
                modify: true
            },
            l6: {
                navTo: '/fmc/index',
            },
            r1: {},
        }
    }
    
    let screen = page1

    that.$store.commit(REGSCREEN, screen)
}

function initAcarsIndex(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{}
    }

    let screen = page1

    that.$store.commit(REGSCREEN, screen)
}

function initDfdauIndex(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{}
    }

    let screen = page1

    that.$store.commit(REGSCREEN, screen)
}

function initSetupIndex(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{
            // l1: {
            //     navTo: '/setup/status',
            // },
            // l2: {
            //     navTo: '/setup/theme',
            // },
            // l3: {
            //     navTo: '/setup/feedback',
            // },
            l4: {
                navTo: '/setup/about',
            },
            l6: {
                navTo: '/menu',
            }
        }
    }
    
    let screen = page1

    that.$store.commit(REGSCREEN, screen)
}

function initAbout(that){
    let page1 = {
        content: that.showData,
        from: '',
        behaviours:{}
    }
    let page2 = {
        content: that.showData,
        from: '',
        behaviours:{
            l6: {
                navTo: '/setup/index',
            }
        }
    }
    
    let screen = ''

    if('page'+that.index[0] === 'page1'){
        screen = page1
    }else if ('page'+that.index[0] === 'page2'){
        screen = page2
    }

    that.$store.commit(REGSCREEN, screen)
}

export{initMenu,initIndex,initIdent,initPos,initPerf,
    initTakeoff,initApproach,initOffset,initNanData,
    initMsgRecall,initAltnDest,
    initRte,initClb,initCrz,initDes,initDepArr,initForecast,
    initFix,initHold,initLegs,initN1Limit,initProg,initNavStatus,
    initMaintIndex,
    initAcarsIndex,
    initDfdauIndex,
    initSetupIndex, initAbout}